import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { CommonModalType } from '@/utils/interfaces'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/card'
import ActionButton from '../common/ActionButton'
import { dispatch, useSelector } from '@/lib/store'
import { calculateAge } from '@/utils/commonFunc'
import PACKAGE_HELPER from '@/helper/packageHelper'
import CART_HELPER from '@/helper/cartHelper'
import { updateCartData } from '@/lib/reducers/cartReducer'
import useCustomToast from '@/hooks/useCustomToast'
import { useRouter } from 'next/navigation'
import { updateOrderData } from '@/lib/reducers/orderReducer'
import { useState } from 'react'

const DuplicateTestFoundModal = ({ open, onOpenChange }: CommonModalType) => {
  const router = useRouter()

  const { handleRemoveDuplicateProductFromCart } = PACKAGE_HELPER()
  const { handleGetCartItems } = CART_HELPER()

  const showToast = useCustomToast()

  const packageState = useSelector((state) => state.package)
  const cartState = useSelector((state) => state.cart)
  const orderState = useSelector((state) => state.order) || {}
  const ACTIVE_USER: any = cartState?.activePatientDetailDto || {}
  const DUPLICATE_PACKAGE_DATA: any = packageState?.duplicateProductData || {}

  const [loading, setLoading] = useState(false)

  const REPEATED_PRODUCT_DATA =
    DUPLICATE_PACKAGE_DATA?.childParentProductNameList || []

  const handleRemoveDuplicates = async () => {
    const formData = {
      patientProductDetailDtoList: [{ ...DUPLICATE_PACKAGE_DATA }],
    }
    setLoading(true)
    const apiResponse: any = await handleRemoveDuplicateProductFromCart(
      formData
    )
    if (apiResponse?.status === true) {
      showToast('success', 'Duplicate items have been removed successfully')
      const res = await handleGetCartItems()
      dispatch(updateCartData({ ...cartState, ...res?.data }))
      dispatch(
        updateOrderData({
          ...orderState,
          cartDtoList: [...res?.data?.cartDtoList],
        })
      )
      setLoading(false)
      onOpenChange(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby="duplicate-tests-description"
        className="modal rounded-none sm:rounded-lg p-0 gap-0 h-full sm:h-auto transition-all border-none flex flex-col"
      >
        <DialogHeader className="p-6 justify-center border-b border-solid border-gray-200">
          <div className="flex jus gap-4 items-center">
            <DialogTitle className="text-body-lg sm:text-heading-md font-bold">
              Duplicate tests found
            </DialogTitle>
          </div>
        </DialogHeader>
        <div className="p-6 flex flex-col justify-between h-full  overflow-y-auto">
          <div>
            <p id="duplicate-tests-description" className="text-label-sm font-semibold text-gray-700 mb-8">
              Following tests are already included in the added packages
            </p>
            <span className="text-label-sm font-semibold text-primary-500">
              {ACTIVE_USER?.firstName} {ACTIVE_USER?.lastName} -{' '}
            </span>{' '}
            <span className="text-label-sm font-semibold text-gray-700">
              {ACTIVE_USER?.age
                ? ACTIVE_USER?.age
                : calculateAge(ACTIVE_USER?.dob)}{' '}
              yrs / {ACTIVE_USER?.gender}
            </span>
            <div className="grid gap-2 ">
              {REPEATED_PRODUCT_DATA &&
                REPEATED_PRODUCT_DATA?.length > 0 &&
                REPEATED_PRODUCT_DATA?.map((item: any) => {
                  return (
                    <Card
                      className="mt-2 p-0 border border-solid border-gray-200 rounded-md shadow-none"
                      key={item?.childProductName}
                    >
                      <CardHeader className="p-0 space-y-0">
                        <CardTitle className="text-label-sm py-2 px-4">
                          {item?.childProductName}
                        </CardTitle>
                        <CardDescription className="text-label-xs font-semibold py-2 px-4 text-danger-600 bg-danger-50">
                          Included in ‘{item?.parentProductName}’
                        </CardDescription>
                      </CardHeader>
                    </Card>
                  )
                })}
            </div>
          </div>
          <DialogFooter className="mt-8">
            <ActionButton variant="primary"
              title="Remove duplicate items"
              loading={loading}
              disabled={loading}
              loadingText="Removing"
              className="text-label-lg font-semibold py-3 w-full"
              onClick={handleRemoveDuplicates}
            />
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DuplicateTestFoundModal
